import { useEffect } from "react";
import Footer from "../../Components/Footer";
import Navbar2 from "../../Components/Navbar2";

import ReactHelmet from "../../Components/ReactHelmet";
export default function SignupVideo() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <ReactHelmet title={"Testifyi Portal Access Video"} description={""} />
      {/* navbar Section */}
      <Navbar2 />

      <div
        style={{
          margin: 0,
          padding: 0,
          background: "linear-gradient(135deg,#002efb,#00c6ff)",
          fontFamily: "Arial, Helvetica, sans-serif",
        }}
      >
        <div
          style={{
            maxWidth: "900px",
            margin: "50px auto",
            padding: "20px",
          }}
        >
          <div
            style={{
              background: "#ffffff",
              borderRadius: "18px",
              boxShadow: "0 15px 40px rgba(0,0,0,0.25)",
              padding: "25px",
            }}
          >
            <div
              style={{
                fontSize: "24px",
                fontWeight: "bold",
                color: "#002efb",
                textAlign: "center",
                marginBottom: "10px",
              }}
            >
              How to Sign Up & Login on Testifyi Portal
            </div>

            <div
              style={{
                fontSize: "14px",
                color: "#555",
                textAlign: "center",
                marginBottom: "20px",
              }}
            >
              Watch this short video to understand how to access your Testifyi
              dashboard and free classes.
            </div>

            {/* Video Container */}
            <div
              style={{
                position: "relative",
                width: "100%",
                paddingTop: "56.25%",
                borderRadius: "14px",
                overflow: "hidden",
                background: "#000",
              }}
            >
              <iframe
                src="https://doc.testifyi.com/videos/Testifyi_Signup.mp4"
                title="Testifyi Sign Up and Login Process"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  border: 0,
                }}
              />
            </div>

            <div
              style={{
                marginTop: "18px",
                fontSize: "13px",
                color: "#444",
                textAlign: "center",
              }}
            >
              If you face any issues while signing up or logging in, please
              contact our support team for assistance.
            </div>
          </div>
        </div>
      </div>
      {/* Top Footer Section*/}
      <section className={"Footer_Top"}>
        <div>
          <div>
            <h1 className={"Font_Rajdhani"}>
              Start Your IELTS Journey With The Best
            </h1>
          </div>
          <div>
            <button className={"Font_Rajdhani"}>Create Account</button>
            <button className={"Font_Rajdhani"}>Login Now</button>
          </div>
        </div>
      </section>
      {/* Footer Section */}
      <Footer />
    </>
  );
}
